var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.buttonClass,attrs:{"title":_vm.item.needs_update ? 'Do not refresh scene' : 'Refresh scene on next scrape'},on:{"click":function($event){return _vm.toggleState()}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"refresh","size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }